module.exports = require('./helpers/bundle-url').getBundleURL('ii3gA') + "logo.7718c6df.svg";